import { defineRecipe } from '@chakra-ui/react';

/** KDS Inline Table Header — contextual banner row above table body. Register as `inlineTableHeader` in theme/system.ts. */
export const inlineTableHeaderRecipe = defineRecipe({
  base: {
    alignItems: 'center',
    display: 'flex',
    h: '12',
    py: '2',
    px: '4',
    gap: '4',
    textStyle: 'default.medium',
    color: 'neutral.400',
    borderColor: 'neutral.100',
    borderStyle: 'solid',
  },
  variants: {
    type: {
      actions: {
        bg: 'brand.50',
        borderBottomWidth: '1px',
      },
      info: {
        bg: 'blue.50',
        borderBottomWidth: '1px',
      },
      warning: {
        bg: 'orange.50',
        borderBottomWidth: '1px',
      },
      error: {
        bg: 'red.50',
        borderBottomWidth: '1px',
      },
      selected: {
        bg: 'brand.50',
        borderBottomWidth: '1px',
        justifyContent: 'space-between',
        color: 'brand.500',
        pl: '3',
      },
    },
  },
  defaultVariants: {
    type: 'actions',
  },
});
